import * as getters from "./getters";

export default {
  namespaced: true,
  state: {
    commande_link: {},
    affichage: {
      rob: "tab-1",
    },
    paramsRob: {
      robId: null,
      structureId: null,
      carteId: null,
      ligneId: null,
    },
    breadCrumbs: {
      rob: null,
      structure: null,
      carte: null,
    },
  },
  getters,
};
